
export class RecoverPasswordResponseError extends Error {
  private status: number;
  public message: string;

  constructor(props: { status: number; message: string }) {
    super(props.message);
    this.status = props.status;
    this.message = props.message;
  }

  get isServerError(): boolean {
    return this.status >= 500;
  }

  get errorMessage(): string {
    return this.message || 'Error inesperado del servidor.';
  }
}

